export default __webpack_public_path__ + "static/media/airplane.ec00d79d.mp3";